import * as React from 'react';
import { FunctionComponent } from 'react';
import { EmptyState, Layout, Divider, Button } from '@iba-team/portal-react-components/dist';
import { ReactComponent as IllAccess } from '../../assets/ill-access.svg';
import { useTranslation } from 'react-i18next';
import './NoPermissionPage.scss';

const NoPermissionPage: FunctionComponent = () => {
  const {t} = useTranslation();

  return (
    <Layout className={'noPermission'}>
      <div className={'noPermission__outer'}>
        <div className={'noPermission__inner'}>
          <EmptyState
            className={'empty'}
            title={t('messagesForBanners.noPermissionBanner.title')}
            description={t('messagesForBanners.noPermissionBanner.body')}
            icon={<IllAccess/>}
          />
          <Divider className={'noPermission__divider'}/>
          <div className={'noPermission__footer'}>
            <span>{t('messagesForBanners.noPermissionBanner.footer1')}</span>
            <a target='_blank' href={'https://help.ibagroup.eu/'} rel="noreferrer">IBA Help</a>
            <span>{t('messagesForBanners.noPermissionBanner.footer2')}</span>
          </div>
        </div>
        <a className={'noPermission__link'} target="_blank" href={'https://my.ibagroup.eu/'} rel="noreferrer">
          <Button
            theme={{ color: 'theme', variant: 'secondary' }}
          >{t('messagesForBanners.noPermissionBanner.btnText')}</Button>
        </a>
      </div>
    </Layout>
    
  );
};

export default NoPermissionPage;